/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import * as stage from "./StagesCase";
import * as stageAdministrativeLaw from "./StagesAdministrativeLaw";
import { StageMetaData } from "../../types/ProductService/ProductService";
import { stageMetaDataCase } from "./StagesCase";
import { stageMetaDataCase as stageMetaDataAdministrativeLawCase } from "./StagesAdministrativeLaw";

export {
  STAGE_CREATED,
  STAGE_DATA_COMPLETED,
  STAGE_WAITING_FOR_FEEDBACK,
  STAGE_DATA_COMPLETED_LAWFIRM,
  STAGE_CHECKED,
  STAGE_IN_PROGRESS,
  STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT,
  STAGE_EXTRAJUDICIAL_REACTION_RECEIVED,
  STAGE_ACTION_REQUIRED,
  STAGE_PREPARE_LAWSUIT,
  STAGE_LAWSUIT,
  STAGE_TRIAL,
  STAGE_EVALUATE_JUDGEMENT,
  STAGE_LAWSUIT_COMPLETED,
  STAGE_COMPLETED,
} from "./StagesCase";

export { STAGE_ADMINISTRATIVE_PROCEEDINGS, STAGE_ADMINISTRATIVE_DECISION_ISSUED } from "./StagesAdministrativeLaw";

export const stageMetaDataCivilServiceLaw: StageMetaData = {
  [stage.STAGE_CREATED]: stageMetaDataCase[stage.STAGE_CREATED],
  [stage.STAGE_DATA_COMPLETED]: stageMetaDataCase[stage.STAGE_DATA_COMPLETED],
  [stage.STAGE_WAITING_FOR_FEEDBACK]: stageMetaDataCase[stage.STAGE_WAITING_FOR_FEEDBACK],
  [stage.STAGE_DATA_COMPLETED_LAWFIRM]: stageMetaDataCase[stage.STAGE_DATA_COMPLETED_LAWFIRM],
  [stage.STAGE_CHECKED]: stageMetaDataCase[stage.STAGE_CHECKED],
  [stageAdministrativeLaw.STAGE_ADMINISTRATIVE_PROCEEDINGS]:
    stageMetaDataAdministrativeLawCase[stageAdministrativeLaw.STAGE_ADMINISTRATIVE_PROCEEDINGS],
  [stageAdministrativeLaw.STAGE_ADMINISTRATIVE_DECISION_ISSUED]:
    stageMetaDataAdministrativeLawCase[stageAdministrativeLaw.STAGE_ADMINISTRATIVE_DECISION_ISSUED],
  [stage.STAGE_IN_PROGRESS]: stageMetaDataCase[stage.STAGE_IN_PROGRESS],
  [stage.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]:
    stageMetaDataAdministrativeLawCase[stage.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT],
  [stage.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED]:
    stageMetaDataAdministrativeLawCase[stage.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED],
  [stage.STAGE_ACTION_REQUIRED]: stageMetaDataCase[stage.STAGE_ACTION_REQUIRED],
  [stage.STAGE_PREPARE_LAWSUIT]: stageMetaDataCase[stage.STAGE_PREPARE_LAWSUIT],
  [stage.STAGE_LAWSUIT]: stageMetaDataCase[stage.STAGE_LAWSUIT],
  [stage.STAGE_TRIAL]: stageMetaDataCase[stage.STAGE_TRIAL],
  [stage.STAGE_EVALUATE_JUDGEMENT]: stageMetaDataCase[stage.STAGE_EVALUATE_JUDGEMENT],
  [stage.STAGE_LAWSUIT_COMPLETED]: stageMetaDataCase[stage.STAGE_LAWSUIT_COMPLETED],
  [stage.STAGE_COMPLETED]: stageMetaDataCase[stage.STAGE_COMPLETED],
};
